// removed by extract-text-webpack-plugin
module.exports = {"Modal":"_32_-amvWF8w07UmzDeLfZb","Video":"DsUIriF__X5TazHKkxddA","Review":"_1p_UqMXjBCJvqZSyG1oUBG","Record":"HsOy0KpavhA81K4v_t1j9","Category":"_28vhysxE1ZsDv7ZESzH3G0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 257
// module chunks = 0